module.exports = __webpack_public_path__ + "img/banner-kr.932bf484.png";